export default "__VITE_ASSET__CZ54JR3h__"